import { render, staticRenderFns } from "./close-facets-group.vue?vue&type=template&id=6c04ace0&"
import script from "./close-facets-group.vue?vue&type=script&lang=ts&"
export * from "./close-facets-group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports